export default __webpack_public_path__ + "static/logo-7262c88720e2a53df2abf086ef2dcb9a.svg";